import Admin from "models/Admin";

// types
export const SET_ADMIN_LIST = "adminList/SET_ADMIN_LIST";
export const CHANGE_SEARCH_FORM = "adminList/CHANGE_SEARCH_FORM";
export const OPEN_ADMIN_MODAL = "adminList/OPEN_ADMIN_MODAL";
export const CLOSE_ADMIN_MODAL = "adminList/CLOSE_ADMIN_MODAL";
export const CHANGE_ADMIN_MODAL_FORM = "adminList/CHANGE_ADMIN_MODAL_FORM";
export const SET_ADMIN_MODAL_ERRORS = "adminList/SET_ADMIN_MODAL_ERRORS";
export const BREAK_ADMIN_LIST = "adminList/BREAK_ADMIN_LIST";

// actions
export const setAdminList = admins => ({
  type: SET_ADMIN_LIST,
  admins: admins.map(admin => new Admin(admin))
});
export const changeSearchForm = (key, value) => ({
  type: CHANGE_SEARCH_FORM,
  key,
  value
});
export const openAdminModal = admin => ({
  type: OPEN_ADMIN_MODAL,
  admin: new Admin(admin)
});
export const closeAdminModal = () => ({
  type: CLOSE_ADMIN_MODAL
});
export const changeAdminModalForm = (key, value) => ({
  type: CHANGE_ADMIN_MODAL_FORM,
  key,
  value
});
export const setErrors = errors => ({
  type: SET_ADMIN_MODAL_ERRORS,
  errors
});
export const breakAdminList = () => ({
  type: BREAK_ADMIN_LIST
});

// state
const initialState = {
  admins: [],
  search: {
    adminKey: "",
    adminName: "",
    showInvalidAdmin: false
  },
  adminModal: {
    open: false,
    admin: new Admin(),
    errors: []
  }
};

// reducers
const adminList = (state = initialState, action) => {
  switch (action.type) {
    case SET_ADMIN_LIST: {
      return { ...state, admins: action.admins };
    }

    case CHANGE_SEARCH_FORM: {
      const { key, value } = action;
      const search = { ...state.search, [key]: value };
      return { ...state, search };
    }

    case OPEN_ADMIN_MODAL: {
      const adminModal = {
        ...state.adminModal,
        open: true,
        admin: action.admin,
        errors: []
      };
      return { ...state, adminModal };
    }

    case CLOSE_ADMIN_MODAL: {
      const adminModal = { ...state.adminModal, open: false };
      return { ...state, adminModal };
    }

    case CHANGE_ADMIN_MODAL_FORM: {
      const { key, value } = action;
      let admin = state.adminModal.admin.set(key, value);
      if (key === "invalidFlg" && value === false) {
        admin = admin.set("invalidReason", "");
      }
      const adminModal = { ...state.adminModal, admin };
      return { ...state, adminModal };
    }

    case SET_ADMIN_MODAL_ERRORS: {
      const { errors } = action;
      const adminModal = { ...state.adminModal, errors };
      return { ...state, adminModal };
    }

    case BREAK_ADMIN_LIST: {
      return initialState;
    }

    default:
      return state;
  }
};

export default adminList;



// WEBPACK FOOTER //
// ./src/redux/modules/adminList.js